import { render, staticRenderFns } from "./TaskStatusMultiSelect.component.vue?vue&type=template&id=2bf811b9&scoped=true&"
import script from "./TaskStatusMultiSelect.component.vue?vue&type=script&lang=js&"
export * from "./TaskStatusMultiSelect.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusMultiSelect.component.vue?vue&type=style&index=0&id=2bf811b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf811b9",
  null
  
)

export default component.exports